export const FORBIDDEN_CHARS = ["@", "/"];
